export default __webpack_public_path__ + "static/media/mark-bruise.0dc089ec.jpg";